/*
 * @Descripttion: 
 * @Author: Rul
 * @Date: 2020-04-01 14:40:11
 * @LastEditors: Rul
 * @LastEditTime: 2020-04-26 10:30:27
 */
import {
  getLayerCreditsConf,
  getVerifyTime,
  getUserCreditsTake,
  getDraw,
  getDrawHistory,
  getOdinChannelIndex,
  getUserCreditsBalance,
  getDrawList,
  getSignToast,
  getBannerList,
  getCategorys,
  getCategoryGoodList,
  getPointsModule,
  getModuleGoodsList,
  getUserInfo,
  getDeviceInfo,
  getServerUserInfo,
} from '@/utils/service'

export const HOME_API = {
  getLayerCreditsConf,
  getVerifyTime,
  getUserCreditsTake,
  getDraw,
  getDrawHistory,
  getOdinChannelIndex,
  getUserCreditsBalance,
  getDrawList,
  getSignToast,
  getBannerList,
  getCategorys,
  getCategoryGoodList,
  getPointsModule,
  getModuleGoodsList,
  getUserInfo,
  getDeviceInfo,
  getServerUserInfo,
}

export const TEST_API = {}
